export default __webpack_public_path__ + "static/media/icon_trash_lrg.0e3e403c.svg";